import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { getSessionInfo } from '../api';
import { signOut } from '../supabase';
import { useSession } from '../useSession';

// "/": who is signed in, plus a session check (the old "Call API" button).
export const Home: React.FC = () => {
    const session = useSession();
    const navigate = useNavigate();

    async function callApi () {
        try {
            const info = await getSessionInfo();
            window.alert('Session Information:\n' + JSON.stringify({ sessionHandle: info.sessionHandle, userId: info.userId }, null, 2));
        } catch (e) {
            window.alert((e as Error).message);
        }
    }

    async function logout () {
        await signOut();
        navigate('/auth');
    }

    return (
        <Box className="center">
            <Card sx={{ width: 480, maxWidth: '100%' }}>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h5">Login successful</Typography>
                        <Typography>Signed in as <b>{session?.user.email}</b></Typography>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" onClick={callApi}>Call API</Button>
                            <Button variant="outlined" component={RouterLink} to="/admin">Admin</Button>
                            <Button color="inherit" onClick={logout}>Sign out</Button>
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
};
